import React from 'react';

import { classnames } from '@lumapps/classnames';
import { Heading as LumxHeading, HeadingProps, HeadingLevelProvider } from '@lumapps/lumx/react';
import { ALIGNMENTS, ALIGNMENT_CLASSES } from '@lumapps/wrex/constants';
import type { ElementRender } from '@lumapps/wrex/types';

import { HEADING } from '../../../constants';
import type { HeadingElement } from '../../../types';

import './index.scss';

export const WREX_HEADING_CLASSNAME = 'wrex-content-title';

export const Heading: ElementRender<HeadingElement, HTMLHeadingElement> = (props) => {
    const { children, className, elementRef, element, ...forwardedProps } = props;
    const alignment = element?.alignment ? element.alignment : ALIGNMENTS.start;
    return (
        <>
            {Array(element && element.level > 1 ? element.level - 1 : 0)
                .fill(HeadingLevelProvider)
                .reduceRight(
                    (Acc, Comp) => (
                        <Comp>{Acc}</Comp>
                    ),
                    <LumxHeading
                        {...(forwardedProps as HeadingProps)}
                        className={classnames(
                            className,
                            `${WREX_HEADING_CLASSNAME}${element?.level}`,
                            // Support old classes for backward compatibility with custom CSS
                            {
                                1: 'wrex-content-headline',
                                2: 'wrex-content-title',
                                3: 'wrex-content-subtitle',
                                4: null,
                                5: null,
                                6: null,
                            }[element?.level || 1],
                            ALIGNMENT_CLASSES[alignment],
                        )}
                        ref={elementRef}
                    >
                        {children}
                    </LumxHeading>,
                )}
        </>
    );
};
Heading.displayName = HEADING;
